import { useForm } from "react-hook-form";

import { Radio } from "components/form_components/Inputs";
import Button from "components/ui/button/Button";

import css from "./SavedViewForm.module.scss";

type FormValues = {
  viewName: string;
  viewDescription: string;
  alertFrequency: "DAILY" | "WEEKLY" | "NEVER";
};

export function AlertForm({
  defaultValues,
  onSubmit,
  onCancel,
  isLoading,
}: {
  defaultValues?: FormValues;
  isStandardView?: boolean;
  onSubmit: (data: FormValues) => void;
  onCancel: () => void;
  isLoading?: boolean;
}) {
  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues,
  });

  const title = "Email me about new activity in this search";

  return (
    <form className={css.form} onSubmit={handleSubmit((d) => onSubmit(d))}>
      {defaultValues && (
        <Radio
          label={title}
          name={"alertFrequency"}
          control={control}
          options={[
            { label: "Daily", value: "DAILY" },
            { label: "Weekly", value: "WEEKLY" },
            { label: "Never", value: "NEVER" },
          ]}
          optionType="default"
        />
      )}
      <div className={css.formActions}>
        <Button buttonType="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={isLoading}>
          Save
        </Button>
      </div>
    </form>
  );
}
